import { Link, useParams } from "react-router";
import { useStaffWorkspace } from "../../../app/session";
import { ErrorState, Loading, NoAccess } from "../../../components/States";
import { InvoicePaper } from "../../../components/InvoicePaper";
import { useInvoiceDetail } from "./detail-data";
import { useDocModel } from "./RechnungDetail";
import "../vertraege/vertraege.css";
import { t } from "../../../lib/sprache";

/**
 * Druckansicht einer Rechnung: nur das Dokument; „Als PDF sichern“ über den Druckdialog des Browsers. Dasselbe Modell wie das
 * archivierte PDF (eingefrorene Angaben mit Register, Vertretung, Bank, Logo und Farbe der Agentur; Befund Einstellungen 7).
 */
export function RechnungDruck() {
  const { invoiceId = "" } = useParams();
  const ws = useStaffWorkspace();
  const detail = useInvoiceDetail(ws.org.org_id, invoiceId);
  const doc = useDocModel(detail.data ?? undefined, ws.org.name);
  if (detail.error) return <ErrorState error={detail.error} retry={() => void detail.refetch()} />;
  if (detail.isPending || (detail.data && !doc.model)) return <Loading />;
  if (!detail.data || !doc.model) return <NoAccess text={t("Diese Rechnung gibt es nicht oder sie ist für dein Konto nicht sichtbar.", "This invoice does not exist or is not visible to your account.")} />;
  // Übernommene Rechnung (0064): gedruckt wird das Original aus dem bisherigen System, kein Nachbau
  if (detail.data.invoice.imported) {
    return (
      <main id="main" className="content stack">
        <h1 className="sr-only">{t("Druckansicht", "Print view")} · {detail.data.invoice.number ?? t("Rechnung", "Invoice")}</h1>
        <div className="notice" role="status">{t("Diese Rechnung stammt aus dem bisherigen System. Zum Drucken bitte das Original-PDF an der Rechnung öffnen.", "This invoice comes from the previous system. To print, please open the original PDF on the invoice.")}</div>
        <div className="row"><Link className="btn" to={`/agentur/rechnungen/${invoiceId}`}>{t("Zurück zur Rechnung", "Back to the invoice")}</Link></div>
      </main>
    );
  }
  return (
    <main id="main" className="content stack">
      {/* Seitenüberschrift für Vorleser; sichtbar ist der Beleg selbst (SICHT-AGENTUR-GELD-15) */}
      <h1 className="sr-only">{t("Druckansicht", "Print view")} · {doc.model.number}</h1>
      <div className="row between tk-noprint">
        <Link className="btn" to={`/agentur/rechnungen/${invoiceId}`}>{t("Zurück zur Rechnung", "Back to the invoice")}</Link>
        <button className="primary" type="button" onClick={() => window.print()}>{t("Drucken oder als PDF sichern", "Print or save as PDF")}</button>
      </div>
      <InvoicePaper m={doc.model} logoUrl={doc.logoUrl} />
    </main>
  );
}
